import * as React from "react";
import {default as AppUtils, LOADING_STATE} from "../../utils/AppUtils"
import EditViewCard, {EditViewDisplayMode} from "../../components/common/EditViewCard"
import AppLoader from "../../components/utils/AppLoader"
import * as _ from "lodash";
import ModelFactory from "../../models/ModelFactory"
import IPatientCondition from "../../models/IPatientCondition";
import {PatientConditionsEditorProps} from "../../components/patient/edit/PatientConditionsEditor";
import {PatientConditionsViewProps} from "../../components/patient/view/PatientConditionView";
import IConditionsUI from "../../models/IConditionsUI";
import {AppConstants, SourceConstants} from "../../utils/AppConstants";
import IEditedBy from "../../models/IEditedBy";
import IStaticDataValue from "../../../../common/models/IStaticDataValue";
import {ITypeFormQuestionnaire} from "../../models/ITypeFormQuestionnaire";
import ErrorContainer from "./../ErrorContainer"

/**
 * Created by aditya on 26/02/18.
 */

export interface PastConditionsEditViewContProps {
    appointmentId?: number,
    editedBy: IEditedBy,
    patientId: number,
    displayMode?: EditViewDisplayMode,
    patientConditions: IConditionsUI[],
    familyConditions?: IPatientCondition[],
    staticConditions?: IStaticDataValue[],
    fetchPatientConditions?: (patientId: number) => any,
    fetchStaticSymptomsData?: (input: string) => Promise<any>,
    savePatientConditions?: (patientId: number, patientConditions: IPatientCondition[]) => any;
    questionnaire?: ITypeFormQuestionnaire[];
    typeFormMapping?: any;
}


export interface PastConditionsEditViewContState {
    updatedConditions: {item: IConditionsUI}[],
    isPatientConditionsDataLoaded: LOADING_STATE,
    error: string,
    errorDetails: string
}

class PastConditionsEditViewCont extends React.Component<PastConditionsEditViewContProps, PastConditionsEditViewContState> {

    constructor(props: PastConditionsEditViewContProps) {
        super(props);
        this.state = this.getStateFromProps(props);
    }

    componentWillReceiveProps(props: PastConditionsEditViewContProps) {
        this.setState(this.getStateFromProps(props));
    }

    getUpdatedConditionsFromProps = (props: PastConditionsEditViewContProps): {item: IConditionsUI}[] => {
        let currUpdatedConditions: {item: IConditionsUI}[] = [];
        _.map(props.patientConditions, function(condition){
            let clonePatientConditions = Object.assign({}, condition);
            currUpdatedConditions.push({item: clonePatientConditions});
        });
        return currUpdatedConditions;
    }

    getStateFromProps = (props: PastConditionsEditViewContProps) => {
        let currState: PastConditionsEditViewContState = {
            updatedConditions: [],
            isPatientConditionsDataLoaded: LOADING_STATE.NOT_INITIALIZED,
            error: "",
            errorDetails: ""
        }
        if ( _.isNull(props.patientConditions) ) {
            props.fetchPatientConditions(this.props.patientId);
            currState.isPatientConditionsDataLoaded = LOADING_STATE.LOADING;
        } else {
            currState.updatedConditions = this.getUpdatedConditionsFromProps(props);
            currState.isPatientConditionsDataLoaded = LOADING_STATE.LOADED;
        }
        return currState;
    }

    getConditionEditViewTemplateProps = () => {
        let patientConditionViewProps: PatientConditionsViewProps = {
            conditions: this.props.patientConditions,
            questionnaire: this.props.questionnaire,
            questionIdList: this.typeFormQuestionIdList()
        }
        let patientSurgeryEditorProps: PatientConditionsEditorProps = {
            fetchStaticSymptomData: this.props.fetchStaticSymptomsData,
            staticConditions: this.props.staticConditions,
            showRelationshipDropdown: false,
            updatedConditions: this.state.updatedConditions,
            updateConditions: this.updatePatientConditions,
            questionnaire: this.props.questionnaire,
            questionIdList: this.typeFormQuestionIdList()
        }
        return {"view": patientConditionViewProps, "edit": patientSurgeryEditorProps};
    }

    updatePatientConditions = (updatedConditions: {item: IConditionsUI}[]): void => {
        this.setState({updatedConditions: updatedConditions});
    }

    savePatientConditions = () => {
        let myInstance = this;
        let saveConditionsList: IPatientCondition[] = this.getSaveObject();
        if (!_.isEmpty(this.props.familyConditions)) saveConditionsList = saveConditionsList.concat(this.props.familyConditions);
        // if (saveConditionsList.length > 0 ) {
        if (this.isFormDirty()) {
            this.setState({
                error: "Cannot save Conditions",
                errorDetails: "Please fill in all the mandatory fields before proceeding"
            })
        } else {
            this.setState({isPatientConditionsDataLoaded: LOADING_STATE.NOT_INITIALIZED});
            this.props.savePatientConditions(this.props.patientId, saveConditionsList).then(function(){
                myInstance.setState({isPatientConditionsDataLoaded: LOADING_STATE.LOADED});
            });
        }
        // }
    }

    getSaveObject = (): IPatientCondition[] => {
        let saveConditions: IPatientCondition[] = [];
        let editorId = this.props.editedBy.id;
        let role = this.props.editedBy.role;
        let appointmentId = this.props.appointmentId;
        let patientId = this.props.patientId;
        _.map(this.state.updatedConditions, function(updatedConditionItem: {item: IConditionsUI}){
            if ( updatedConditionItem.item.items.length > 0 ) {
                _.map(updatedConditionItem.item.items, (listItem) => {
                    // if (ModelFactory.isValidCondition(listItem)) {
                    let updatedCondition = AppUtils.sanitizeRequestItemBeforeSave(listItem);
                    updatedCondition.relationship = AppConstants.PatientRelationshipConstant.SELF.internalValue;
                    updatedCondition.source = SourceConstants.DOCSASPP;
                    updatedCondition.lastEditedPersonId = parseInt(editorId);
                    updatedCondition.personType = role.toLowerCase();
                    updatedCondition.appointmentId = appointmentId;
                    updatedCondition.patientId = patientId;
                    updatedCondition.isDeleted = false;
                    saveConditions.push(updatedCondition);
                    // }
                })
            } else {
                if ( !_.isEmpty(updatedConditionItem.item.name) ) {
                    let listItem = ModelFactory.createNewPatientCondition();
                    listItem.displayValue = updatedConditionItem.item.name;
                    listItem.internalValue = updatedConditionItem.item.name.toLowerCase();
                    listItem.relationship = AppConstants.PatientRelationshipConstant.SELF.internalValue;
                    listItem.source = SourceConstants.DOCSASPP;
                    listItem.lastEditedPersonId = parseInt(editorId);
                    listItem.personType = role.toLowerCase();
                    saveConditions.push(listItem);
                }
            }
        })
        return saveConditions;
    }

    isFormDirty = (): boolean => {
        let status = false;
        _.map(this.state.updatedConditions, function(updatedConditionItem: {item: IConditionsUI}){
            if ( updatedConditionItem.item.items.length > 0 ) {
                _.map(updatedConditionItem.item.items, (listItem) => {
                    if (!ModelFactory.isValidCondition(listItem)) {
                        status = true;
                        return false;
                    }
                })
            } else {
                if ( _.isEmpty(updatedConditionItem.item.name) ) {
                    status = true;
                    return false;
                }
            }
        })
        return status;
    }

    cancelActionHandler = () => {
        this.setState({updatedConditions: this.getUpdatedConditionsFromProps(this.props)});
    }

    typeFormQuestionIdList = (): string[] => {
        let questionList = [];
        questionList = this.props.typeFormMapping.filter(item => item.group === "MEDICAL_CONDITIONS");
        if (!_.isEmpty(questionList)) {
            questionList = questionList.map(item => item.code);
        }
        return questionList;
    }

    clearErrorMessage = () => {
        this.setState({
            error: "",
            errorDetails: ""
        })
    }

    render() {
        let isLoaded =  this.state.isPatientConditionsDataLoaded === LOADING_STATE.LOADED;
        let errorMessage = !_.isEmpty(this.state.error) ? this.state.error : null;
        let errorDetails = !_.isEmpty(this.state.errorDetails) ? this.state.errorDetails : "";
        return (
            <div>
                {
                    !_.isNull(errorMessage) &&
                    <ErrorContainer errorText={errorMessage} errorDetails={errorDetails} errorCode={0} closeError={this.clearErrorMessage}/>
                }
                {
                    isLoaded &&
                    <EditViewCard cardTitleDisplay={"Past Conditions"} templateName={"conditions"}
                                  templateProps={this.getConditionEditViewTemplateProps()}
                                  lastEditedEpoch={new Date().getTime()} saveActionHandler={this.savePatientConditions}
                                  cancelActionHandler={this.cancelActionHandler}
                                  displayMode={this.props.displayMode}
                    />
                }
                {
                    !isLoaded &&
                    <AppLoader/>
                }
            </div>
        );
    }
}

export default PastConditionsEditViewCont